/* eslint-disable default-case */

// Core
import { useState, useEffect } from "react";

//Components
import { Gender } from "./components/Gender";
import { QuestionOne } from "./components/QuestionOne";
import { QuestionTwo } from "./components/QuestionTwo";
import { QuestionThree } from "./components/QuestionThree";
import { Name } from "./components/Name";
import { Birthday } from "./components/Birthday";
import { Email } from "./components/Email";
import { Password } from "./components/Password";
import { landingId } from "./constants";

const contentWrapper = document.querySelector(".content");
const videoMobile = document.querySelector(".video__mobile");

function App() {
  const [formData, setFormData] = useState({});
  const [step, setStep] = useState(1);
  const [intFrameWidth, setIntFrameWidth] = useState(window.innerWidth);
  const handleResize = () => {
    setIntFrameWidth(window.innerWidth);
  };

  useEffect(() => {
    const signInButton = document.querySelector(".login-btn");
    const search = window.location.search;
    const lndId =
      search === ""
        ? `?landing_id=${landingId}`
        : `${search}&landing_id=${landingId}`;

    if (signInButton) {
      signInButton?.setAttribute("href", `/login${lndId}`);
    }
  }, []);

  useEffect(() => {
    if (step === 8) {
      videoMobile.classList.add("hide");
      if (intFrameWidth <= 430) {
        contentWrapper.classList.add("last__step");
      } else {
        contentWrapper.classList.remove("last__step");
      }
    }
  }, [step, intFrameWidth]);
  let content = null;

  switch (step) {
    case 1:
      content = (
        <>
          <Gender
            nextStep={() => setStep(2)}
            setData={setFormData}
            data={formData}
          />
        </>
      );
      break;
    case 2:
      content = (
        <>
          <QuestionOne nextStep={() => setStep(3)} />
        </>
      );
      break;
    case 3:
      content = (
        <>
          <QuestionTwo nextStep={() => setStep(4)} />
        </>
      );
      break;
    case 4:
      content = (
        <>
          <QuestionThree nextStep={() => setStep(5)} />
        </>
      );
      break;
    case 5:
      content = (
        <>
          <Name
            nextStep={() => setStep(6)}
            setData={setFormData}
            data={formData}
          />
        </>
      );
      break;
    case 6:
      content = (
        <>
          <Birthday
            nextStep={() => setStep(7)}
            setData={setFormData}
            data={formData}
          />
        </>
      );
      break;
    case 7:
      content = (
        <>
          <Email
            nextStep={() => setStep(8)}
            setData={setFormData}
            data={formData}
          />
        </>
      );
      break;
    case 8:
      content = (
        <>
          <Password setData={setFormData} data={formData} />
        </>
      );
  }

  return <div>{content}</div>;
}

export default App;
